<template>
    <Layout :isLogin="true">
        <div slot="epassport">
            <iframe v-if="showIframe" ref="iframe" :src="IFRAME_URL"></iframe>
        </div>
    </Layout>
</template>

<script>
import { sdk } from 'data';

const IFRAME_URL = sdk('LOGIN');

const showIframe = window === window.top;
if (!showIframe) {
    window.top.location.href = '/login.html';
}
export default {
    data() {
        return {
            showIframe,
            IFRAME_URL,
        };
    },
};
</script>

<style lang="scss">
.vss-layout.phone {
    .epassport {
        .el-dialog {
            width: 95%;
            max-width: 334px;
        }
    }
}
.vss-layout.pc {
    .epassport {
        .el-dialog {
            width: 334px;
        }
    }
}
.el-dialog__body.el-dialog__body_epassport .el-dialog-epassport {
    height: 360px;
}
</style>
